import { UsersViews } from '../../constants/views';
import { userUpdated } from './usersSlice';

export const updateUser =
  ({ user }) =>
  async (dispatch) => {
    dispatch(userUpdated({ user }));
  };

export const fetchUserSelectOptions =
  (search) =>
  (_dispatch, _getState, { gccApiClient }) => {
    return gccApiClient.getUsers({ search, view: UsersViews.SELECT_OPTIONS });
  };
